<template>
  <div class="text-center">
    <v-dialog persistent v-model="visible" width="800">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-eye</v-icon> Visualizar Habilidade
          </div>
        </v-toolbar>
        <div class="container dialog">
          <v-row class="d-flex justify-center mt-7">
            <v-col cols="12">
              <v-text-field
                v-model="content.nome"
                label="Habilidade"
                counter="25"
                maxlength="25"
                readonly
                outlined
                dense
                :rules="[(v) => $required(v), (v) => $max(v, 25)]"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="content.codigo"
                label="Código da Habilidade"
                readonly
                dense
                outlined
                counter="25"
                maxlength="25"
                persistent-hint
                hint="O código informado deve ser o mesmo disponibilizado pelo MEC."
                v-transform-case
                :rules="[(v) => $required(v), (v) => $max(v, 25)]"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="content.descricao"
                label="O que será avaliado"
                counter="2500"
                maxlength="2500"
                readonly
                dense
                outlined
                :rules="[(v) => $required(v), (v) => $max(v, 2500)]"
              ></v-textarea>
            </v-col>
          </v-row>
        </div>
        <div class="btn-group text-center">
          <v-btn color="primary" @click="$emit('onClose')">
            <v-icon>mdi-close</v-icon>
            Fechar
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { DialogProps } from '~/commons/classes/dialog-props';
import { Habilidade } from '~/commons/classes/habilidade';

export default {
  props: new DialogProps(Habilidade),
};
</script>
